import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { getViewForChart, getVisibleEntriesForView } from '../../redux/sonar/sonarSelectors';
import { SONAR_SECTIONS } from '../../constants';
import { SONAR_DATA_KEYS } from '../../utils/chart';
import { Panel } from '../../components/layout/layout';
import WithToolbarWrapper from '../with-toolbar-wrapper/WithToolbarWrapper';
import ViewRadioGroup from '../view-radio-group/ViewRadioGroup';
import Area from '../../components/charts/apex/area/Area';

import scss from './Presence.module.scss';

const CHART_INDEX = 0;

function Presence() {
  const { t } = useTranslation('sonar');
  const view = useSelector(getViewForChart(SONAR_SECTIONS.FOOTPRINT, CHART_INDEX));

  const domainEntries = useSelector(getVisibleEntriesForView(view));

  return (
    <Panel>
      <WithToolbarWrapper>
        <ViewRadioGroup chartIndex={CHART_INDEX} section={SONAR_SECTIONS.FOOTPRINT} />

        <div className={scss.innerWrapper}>
          <Area
            data={domainEntries}
            dataKey={SONAR_DATA_KEYS.PRESENCE}
            title={t('reach')}
            customTooltip
            isShowTrend
          />
          <Area data={domainEntries} dataKey={SONAR_DATA_KEYS.ENERGY} title={t('vitality')} customTooltip isShowTrend />
        </div>
      </WithToolbarWrapper>
    </Panel>
  );
}

export default Presence;
